// src/components/news/NewsMeta.jsx
import React from "react";
import { CalendarIcon, TagIcon } from "@heroicons/react/24/outline";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const NewsMeta = ({ date, product }) => {
  if (!date && !product) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-8">
      {date && (
        <div className="flex items-center gap-2 text-gray-600">
          <CalendarIcon className="h-5 w-5 text-green-600" />
          <span className="text-sm sm:text-base font-medium">
            {formatDate(date)}
          </span>
        </div>
      )}
      {product && (
        <div className="flex items-center gap-2">
          <TagIcon className="h-5 w-5 text-gray-600" />
          <span className="inline-block px-3 py-1 bg-gray-100 text-gray-800 text-xs sm:text-sm font-semibold rounded-full">
            {product}
          </span>
        </div>
      )}
    </div>
  );
};

export default NewsMeta;



